/**
 * As bs5 use new HTML structure for radio buttons, it will be too much work for us to make the feature correct
 * in many different pages. So we still keep same HTML but implement the feature from bs3
 */

$(function() {
    $(document)
        .on('click.cus.button', '[data-cus-toggle^="button"]', function(e) {
            let $btn = $(e.target).closest('.btn');
            let changed = true
            let $parent = $btn.closest('[data-cus-toggle="buttons"]')

            if ($parent.length) {
                let $input = $btn.find('input')
                if ($input.prop('type') == 'radio') {
                    if ($input.prop('checked')) changed = false
                    $parent.find('.active').removeClass('active')
                    $btn.addClass('active')
                } else if ($input.prop('type') == 'checkbox') {
                    if (($input.prop('checked')) !== $btn.hasClass('active')) changed = false
                    $btn.toggleClass('active')
                }

                $input.prop('checked', $btn.hasClass('active'))
                if (changed) $input.trigger('change')
            } else {
                $btn.attr('aria-pressed', !$btn.hasClass('active'))
                $btn.toggleClass('active')
            }

            /* This code cause issue on Update Contact Details page now, comment now
            if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
                // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
                e.preventDefault()
                // The target component still receive the focus
                if ($btn.is('input,button')) $btn.trigger('focus')
                else $btn.find('input:visible,button:visible').first().trigger('focus')
            }
            */
        })
        .on('focus.cus.button blur.cus.button', '[data-cus-toggle^="button"]', function (e) {
            $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
        })
});